<template>
  <div>
    <van-nav-bar class="bg-gradual-blue" title="场馆预约" left-text="返回" @click-left="goback();" left-arrow />
    <div>
      <van-form @submit="onSubmit">
        <van-field v-model="reserveData.actTitle" label="预约标题" placeholder="预约标题" :rules="[{ required: true, message: '请填写预约标题' }]"/>
        <van-field v-model="reserveData.reserveDate" readonly label="预约日期" placeholder="预约日期" :rules="[{ required: true, message: '预约日期不能为空' }]" />
        <van-field v-model="reserveData.startTime" readonly label="开始时间" placeholder="开始时间" :rules="[{ required: true, message: '开始时间不能为空' }]" />
        <van-field readonly name="picker" :value="reserveData.endTime" label="结束时间" placeholder="选择结束时间" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="endTimeList" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <van-field v-model="reserveData.tel" type="tel" label="联系电话" placeholder="联系电话" :rules="[{ required: true, message: '联系电话不能为空' }]" />
        <van-field v-model="reserveData.reserveExplain" rows="2" autosize label="预约说明" type="textarea" maxlength="200" placeholder="请输入预约说明" show-word-limit />
        <div style="margin: 20px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
  import { loadData } from '@/utils/common'
  import { Toast } from 'vant';

export default {
  props: {
    rdata: {
      type: Object,
      default: () => {}
    }
  },
  components: { Toast  },
  data() {
    return {
      //座位尺寸
      seatSize:'',
      //推荐选座最大数量
      maxRow:0,
      maxCol:0,
      seatList:[],
      room:{},
      selectSeat:{},
      reserveData:{},
      endTimeList:[],
      showPicker:false
    }
  },
  mounted() {
    this.initData();
  },
  methods:{
    initData(){
      let startIdx =  parseInt(this.rdata.startIndex);
      let endSidx = parseInt(this.rdata.endSidx);
      let endIndex = parseInt(this.rdata.endIndex);
      let startStr = this.getTimeByIdx(startIdx);
      let endStrList = [];
      for (endSidx; endSidx <= endIndex; endSidx++) {
        endStrList.push(this.getTimeByIdx(endSidx));
      }

      this.endTimeList = endStrList;
      this.reserveData = {};
      this.reserveData.startTime = startStr;
      this.reserveData.endTime = endStrList[0];
      this.reserveData.reserveDate = this.rdata.reserveDate;
    },
    getTimeByIdx(idx){
      let time = '';
      if (idx % 2 == 0) {
        time = (idx / 2) + ":00";
      }else {
        time = ((idx - 1) / 2) + ":30";
      }
      if(idx <20){
        return '0'+time;
      }else {
        return time;
      }
    },
    onConfirm(value) {
      this.reserveData.endTime = value;
      this.showPicker = false;
    },
    onSubmit() {
      if(!this.reserveData.endTime){
        Toast('结束时间必选！！');
        return;
      }
      this.reserveData.cgId = this.rdata.sroomId;
      this.reserveData.reserveUser = sessionStorage.getItem('login_userid');
      this.reserveData.userCard = sessionStorage.getItem('login_usercard');
	  this.reserveData.token = sessionStorage.getItem('login_token');
      loadData('/appCg/cgReserve',this.reserveData).then(res => {
        if(res && res.code == 0){
          this.$emit("notice",  {'page':'reserve'})
        }else{
          Toast(res.message);
        }
      }).catch(() => {
        Toast('网络异常请稍后重试！');
      })
    },
    goback(){
      this.$emit("notice",  {'page':'reserve','isback':'1'})
    }

   }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper{
    padding: 20px;
    box-sizing: border-box;
  }
  .cinema-wrapper{
    height:100%;
  }
  .title{
    text-align: center;
  }
  .seat-wrapper{
    height:100%;
    width:100%;
    border:1px dotted #c5c5c5;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }
  .screen{
    margin: 0 auto;
    height:30px;
    width:50%;
    background-color: #e3e3e3;
    border-radius: 0 0 15px 15px;
    color: #585858;
    line-height: 30px;
    text-align: center;
  }
  .inner-seat-wrapper{
    position: absolute;
    top:20px;
    bottom:0;
    width:100%;
    box-sizing: border-box;
  }
  .seat{
    float:left;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inner-seat{
    width:80%;
    height:80%;
    font-size:60%;
    cursor: pointer;
    text-align: center;
    padding-top: 20%;
  }
  .selected-seat{
    background: url('./../../../assets/img/selected.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .unselected-seat{
    background: url('./../../../assets/img/unselected.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .bought-seat{
    background: url('./../../../assets/img/bought.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .screen-center{
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    padding:5px;
    font-size: 13px;
    border-radius: 5px;
    top:50px;
    background-color: #f6f6f6;
    color: #636363;
    border:1px solid #b1b1b1;
  }
  .mid-line{
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    top:100%;
    width:1px;
    height:800px;
    border-left:1px dashed #919191;
  }
  .btn-wrapper{
    margin: 20px auto;
    width:1000px;
    height:30px;
    text-align: center;
  }
  .btn-buy{
    height:100%;
    line-height: 30px;
    font-size: 14px;
    border-radius: 5px;
    padding:0 5px;
    background-color: #ffa349;
    color: #ffffff;
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;
  }
  .smart{
    background-color: #39ac6a;
  }
  .illustration{
    position: absolute;
    left:0;
    top:0;
    height:35px;
    width:300px;
  }
  .illustration-img-wrapper{
    width:25px;
    height:25px;
    position: relative;
    top:50%;
    display: inline-block;
    transform: translateY(-50%);
    margin-left: 10px;
  }
  .illustration-text{
    display: inline-block;
    height:100%;
    line-height: 35px;
    font-size: 14px;
    position: relative;
    top:-2px;
  }

</style>


